import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import { EXPERIENCE_ROUTES } from '@vezeeta/vpay-pack';
import { Cookie } from 'constants/appCookies';
import { getAuthCookieInfo } from 'utils/functions/authentication';
import VpayContent from '../components/VpayContent';
import useVpayAccount from '../hooks/useVpayAccount';
import { createVpayApi } from '../api';
import { getContent } from '../content';

const hrefFor = path => (path === '/' ? '/vpay' : `/vpay${path}`);

export default function VpayContainer() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const culture = Cookies.get(Cookie.CULTURE) || 'en-EG';
  const { userKey } = getAuthCookieInfo();
  const profile = useSelector(state => state.pharmacyAccountManagement.loginInfo.details?.data);
  const email = profile?.email || profile?.username;
  const api = useMemo(() => createVpayApi(userKey, culture, email), [userKey, culture, email]);
  const content = useMemo(() => getContent(culture), [culture]);
  const { state, refresh, retry } = useVpayAccount(api);
  const go = useCallback((path, options) => navigate(hrefFor(path), options), [navigate]);
  const path = pathname.slice('/vpay'.length).replace(/\/$/, '') || '/';
  const requestedRedirect = new URLSearchParams(search).get('redirect');
  const redirectPath = EXPERIENCE_ROUTES.includes(requestedRedirect) ? requestedRedirect : '/';

  return (
    <VpayContent
      culture={culture}
      state={state}
      retry={retry}
      refresh={refresh}
      path={path}
      redirectPath={redirectPath}
      search={search}
      navigate={go}
      hrefFor={hrefFor}
      api={api}
      content={content}
    />
  );
}
